
const listHilights = [
    {company: 'AssurAl', announcement: "Portail web des assurances en Algérie - Secrétariat Permanent du Conseil National des Assurances (CNA)", link : "https://www.cna.dz", image : "/images/assural.gif"},
    {company: 'AXA', announcement: "Annoucement AXA", link : "/", image : "/images/insurance-business.jpg"
}];

export default listHilights;